module.exports = __webpack_public_path__ + "static/media/16-above-input-info-2.dc123f32.png";